import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  background-color: #242424;

  .olho {
    position: absolute;
    width: 20px;
    top: 53%;
    right: 5%;
    z-index: 2;
    opacity: 0.6;
    cursor: pointer;
  }

  #password,
  #acesso,
  #acessoFooter,
  #passwordFooter,
  #aguarde,
  #aguardeFooter,
  #aguardesenha {
    display: none;
  }
`;

export const DivVerificaSenha = styled.div`
    display: none;
    background: #FFF;
    text-align: left;
    width: fit-content !important;
    border-radius: 6px;
    padding: 10px;
    font-size: 12px;
    div {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      padding-bottom: 5px;
      border-bottom: 1px solid #ebebeb;
      :last-child {
        border-bottom: none;
        margin-bottom: 0px;
        padding-bottom: 0px;
      }
      svg {
        margin-right: 5px;
      }
    }
    .scs { color: #479652; }
    .dng { color: #c82c09; }
`;
